import React from "react";
import '../auth.css';
import '../card.css';
import axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import i18n from '../i18n';
import {connect} from 'react-redux'; 
import Menutest from './menu.js';
import { API_BASE_URL } from "../utils/endpoints";
class EditCategory extends React.Component {


 
    state = {

        categoryname:'',
        category_id:''
      };


  componentDidMount(){

    this.setState({categoryname :reactLocalStorage.get('id_user_edit_category_name')})
    this.setState({category_id :reactLocalStorage.get('id_user_edit_category')})

         var lang=i18n.language;
         if(lang ==="ar")
         {
           document.querySelector('.title_edit').style = 'text-align:right;';       
       
         
         }
  }

     handleChange = event => {
     
       this.setState({ categoryName: event.target.value});
     }
 
     handleSubmit = event => {
        event.preventDefault();
        var id_user=this.state.id_user;
        var token=reactLocalStorage.get('accessToken');
    
        const user = {
          'category_name': this.state.categoryName,
          'category_id':this.state.category_id
  
        };
        var data=user;

        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
          apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/updateCategory";
         }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/updateCategory";  
        }


        var headers = {
         'Content-Type': 'application/json',
          'token' :token
          }
        axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
        {
    
        if(response.status === 200)
        {
           
           window.location="group";
    
        }
        else if(response.status === 204){
        console.log("Something wrong");
    
        }
        else{
        console.log("Something wrong");
    
        }
        })
        .catch(function (error) {
        console.log(error);
        });
      }
      back=()=>
      {
        window.location="group";
      }
render(){
    return(
      <div className="big_div">
      <Menutest/>
      <div className="actionMenu">
        <div>
                          <div className="add_form" style={{ paddingBottom: '2%'}}> 
                    <MDBContainer>
                    <MDBRow>
                        <MDBCol md="6">
                        <MDBCard className="add_card">
                            <MDBCardBody>
                            <form onSubmit={this.handleSubmit} className="title_edit">
                                <p className="h4 text-center py-4 text_style">{i18n.t('Edit_Category.label')}</p>
                                <label
                                htmlFor="defaultFormCardNameEx"
                                className="grey-text font-weight-light"
                                >
                                {i18n.t('Name_of_Category.label')}
                                </label>
                                <input
                                type="text"
                                id="defaultFormCardNameEx"
                                className="form-control"
                                required="required"
                                name="text"
                                onChange={this.handleChange}
                                defaultValue={this.state.categoryname}
                                />
                                <br />
                            
                                <div className="text-center py-4 mt-3">
                                <button className="submit_btn_pink">

                                  <MDBBtn color="cyan"  onClick={this.back}>
                                  {i18n.t('Back.label')}
                                  </MDBBtn>
                                  </button>

                                <button className="submit_btn_pink">
                                    <MDBBtn color="cyan" type="submit">
                                    {i18n.t('Submit.label')}
                                    </MDBBtn>
                                    </button>

                                </div>
                            </form>
                            </MDBCardBody>
                        </MDBCard>
                        </MDBCol>
                    </MDBRow>
                    </MDBContainer>
                    </div>
        </div> </div> </div>
    );
}

}


const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (EditCategory);
